// eslint-disable-next-line eag/match-named-export
export const DOC_MIME_TYPE = 'application/msword';
export const DOCX_MIME_TYPE =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export const XLS_MIME_TYPE = 'application/vnd.ms-excel';
export const XLSX_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const PDF_MIME_TYPE = 'application/pdf';

export const JPEG_MIME_TYPE = 'image/jpeg';
export const PNG_MIME_TYPE = 'image/png';
export const GIF_MIME_TYPE = 'image/gif';
export const HEIC_MIME_TYPE = 'image/heic';
export const HTML_MIME_TYPE = 'text/html';

export const CSV_MIME_TYPE = 'text/csv';
